import { type FC } from 'react'
import classNames from 'classnames'
import { type StepStatus } from '../domain/flow'
import styles from '../AccountOpeningWizard.module.scss'

interface StepRailProps {
  number: number
  icon?: string
  status: StepStatus
  isLast: boolean
}

export const StepRail: FC<StepRailProps> = ({ number, icon, status, isLast }) => {
  return (
    <div className={classNames('d-flex flex-column align-items-center flex-shrink-0', styles.stepRail)}>
      <span
        className={classNames(
          'rounded-3 d-flex align-items-center justify-content-center flex-shrink-0',
          styles.stepRailIcon,
          status === 'done'
            ? classNames('zocks-bg-color-success-background', styles.stepRailIconDone)
            : 'zocks-bg-color-gray-100 border zocks-border-color-gray-200',
        )}
      >
        {status === 'done' ? (
          <i className='bi bi-check zocks-text-success' />
        ) : icon ? (
          <i className={classNames('bi', `bi-${icon}`)} />
        ) : (
          <span className='paragraph-small medium'>{number}</span>
        )}
      </span>
      {isLast ? null : <div className={classNames('flex-grow-1', styles.stepRailLine)} />}
    </div>
  )
}
